import { TextField, Typography } from "@material-ui/core";
import React from "react";
import AppTooltip from "./AppTooltip";

const PasswordField = (props) => {
  return (
    <AppTooltip
      title={
        <>
          <Typography variant="h6" gutterBottom>
            Password must have:
          </Typography>
          <Typography>
            {"Atleast 8 characters"}
            <br />
            {"At least one uppercase letter"}
            <br />
            {"At least one lowercase letter"}
            <br />
            {"At least one number"}
            <br />
            {"Inclusion of atleast one special character, e.g.., @$!%*?#^&"}
          </Typography>
        </>
      }
      placement="right"
      arrow
    >
      <TextField {...props} />
    </AppTooltip>
  );
};
export default PasswordField;
